import { render, staticRenderFns } from "./DialogEditDepartmentRecord.vue?vue&type=template&id=1b344525&scoped=true&"
import script from "./DialogEditDepartmentRecord.vue?vue&type=script&lang=js&"
export * from "./DialogEditDepartmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditDepartmentRecord.vue?vue&type=style&index=0&id=1b344525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b344525",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VContainer,VDatePicker,VDialog,VIcon,VMenu,VRow,VSpacer,VTextField})
